import React from "react";

/**
 * Cleveland Creative Group — Official brand mark.
 *
 * "Offset" — Four horizontal bars stacked like masonry, each shifted
 * horizontally from the last. The cyan second-from-top bar anchors the
 * composition. Reads as: modular, engineered, assembled, built to fit.
 *
 * - Symmetric bar widths, staggered positions = structure + motion
 * - Cyan accent on bar 2 = the "custom" piece
 * - On :hover (opt-in via parent .group), bars slide to aligned state
 * - Scales cleanly from 16px (favicon) to 200px (footer).
 */

const CYAN = "#22D3EE";
const CYAN_EDGE = "#0EA5E9";
const WHITE = "#F8FAFC";
const SLATE = "#475569";

export const LogoMark = ({ size = 40, className = "", animated = true }) => (
  <svg
    viewBox="0 0 40 40"
    width={size}
    height={size}
    className={`${className} ${animated ? "ccg-mark" : ""}`}
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Cleveland Creative Group"
  >
    <defs>
      <linearGradient id="ccg-cyan" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor={CYAN} />
        <stop offset="100%" stopColor={CYAN_EDGE} />
      </linearGradient>
    </defs>
    {/* Bar 1 — top, white, right-leaning */}
    <rect
      className="ccg-bar ccg-bar-1"
      x="10"
      y="8"
      width="18"
      height="4"
      rx="1"
      fill={WHITE}
    />
    {/* Bar 2 — cyan accent, further right */}
    <rect
      className="ccg-bar ccg-bar-2"
      x="14"
      y="14"
      width="18"
      height="4"
      rx="1"
      fill="url(#ccg-cyan)"
    />
    {/* Bar 3 — white, left-leaning */}
    <rect
      className="ccg-bar ccg-bar-3"
      x="8"
      y="20"
      width="18"
      height="4"
      rx="1"
      fill={WHITE}
    />
    {/* Bar 4 — muted slate, bottom */}
    <rect
      className="ccg-bar ccg-bar-4"
      x="12"
      y="26"
      width="18"
      height="4"
      rx="1"
      fill={SLATE}
    />
  </svg>
);

export const LogoLockup = ({
  size = 36,
  className = "",
  textClassName = "text-slate-100",
  animated = true,
  showTag = true,
}) => (
  <div className={`flex items-center gap-3 group ${className}`}>
    <LogoMark size={size} animated={animated} />
    <div className="flex flex-col leading-none">
      <span
        className={`font-display font-semibold tracking-tight ${textClassName}`}
        style={{ fontSize: size * 0.42 }}
      >
        Cleveland Creative
      </span>
      {showTag && (
        <span
          className="font-mono uppercase tracking-[0.22em] text-cyan-400/80 mt-1"
          style={{ fontSize: size * 0.22 }}
        >
          Group · Custom Software
        </span>
      )}
    </div>
  </div>
);

export default LogoMark;
